import React, { useState, useEffect } from "react";
import SidebarRFQ from "../POpage/SidebarRFQ";
import unreadicon from "../assets/images/unreadicon.png";
import timeicon from "../assets/images/timeicon.png";
import { Link } from "react-router-dom";
import axios from "axios";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
dayjs.extend(relativeTime);

const AlertMessage = () => {
  const user = JSON.parse(localStorage.getItem("userdata"));
  const [rfqMessages, setRFQMessages] = useState([]);
  const [poMessages, setPOMessages] = useState([]);

  useEffect(() => {
    if (user?.id) {
      fetchMessagesRFQ();
      fetchMessagesPO();
    }
  }, []);

  const fetchMessagesRFQ = async () => {
    try {
      const response = await axios.get(`https://bimanager.nexteck.uk/api/messagesrfq/${user.id}`);
      setRFQMessages(response.data.messages.slice(0,5));
    } catch (err) {
      console.error("RFQ fetch error:", err);
    }
  };

  const fetchMessagesPO = async () => {
    try {
      const response = await axios.get(`https://bimanager.nexteck.uk/api/messagespo/${user.id}`);
      setPOMessages(response.data.messages.slice(0,5));
    } catch (err) {
      console.error("PO fetch error:", err);
    }
  };

  const markAsRead = async (id) => {
    try {
      await axios.post(`https://bimanager.nexteck.uk/api/messages/status-update`, {
        id,
        client_id: user.id,
      });
      fetchMessagesRFQ();
      fetchMessagesPO();
    } catch (err) {
      console.error("Status update failed", err);
    }
  };

  const renderMessageCard = (messages, type) =>
    messages.map((alert) => (
      <div
        key={alert.id}
        className="d-flex justify-content-between align-items-center bglight p-2 mb-3"
        style={{ cursor: "pointer" }}
        onClick={() => markAsRead(alert.id)}
      >
        {/* Left: Message */}
        <div className="d-flex align-items-center">
          <div>
            <div className="fw-semibold mx-2">{alert.message}</div>
          </div>
        </div>

        {/* Right: Status & Time */}
        <div className="d-flex justify-content-end align-items-center gap-4">
          <div className="text-center">
            <img
              src={unreadicon}
              alt="Unread Icon"
              style={{ width: "20px", height: "20px" }}
              className="mb-1"
            />
            <div className="small text-muted mx-2">
              {alert.status === "0" ? "Unread" : "Read"}
            </div>
          </div>
          <div className="text-center">
            <img
              src={timeicon}
              alt="Time Icon"
              style={{ width: "20px", height: "20px" }}
              className="mb-1"
            />
            <div className="small text-muted mx-2">
              {dayjs(alert.created_at).fromNow()}
            </div>
          </div>
        </div>
      </div>
    ));

  return (
    <div className="row">
      <div className="custom-2-5">
        <SidebarRFQ />
      </div>
      <div className="custom-9-5 dashboardsclooer p-4">
        <h2 className="text-xl font-bold mb-4">Alert Message</h2>
        <div className="row">
          <div className="col-lg-6">
            <div className="card p-3 shadowsm">
              <h6 className="fw-bold mb-3">RFQ Alerts</h6>
              {renderMessageCard(rfqMessages, "RFQ")}
              <Link to="/alertall">
                <span>All View</span>
              </Link>
            </div>
          </div>
          <div className="col-lg-6">
            <div className="card p-3 shadowsm">
              <h6 className="fw-bold mb-3">PO Alerts</h6>
              {renderMessageCard(poMessages, "PO")}
              <Link to="/alertallpo">
                <span>All View</span>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AlertMessage;
